@if (incomeTaxEntity$ | async; as incomeTaxEntity) {
  <form [formGroup]="formGroup">
    <div formArrayName="reiskostenEigenZorg">
      @for (item of reiskostenEigenZorg.controls; track item; let i = $index) {
        @let aangifteJaar = incomeTaxEntity.aangifte?.aangifteJaar ?? 2024;
        <div [formGroupName]="i" class="row" style="--bs-gutter-x: 0.5rem;">
          <snelstart-ui-number-form-control [decimals]="0"
                                            [label]="i === 0 ? 'Aantal km' : ''"
                                            class="col-auto custom-input-125"
                                            formControlName="aantalKilometersNaartArtsZiekenhuis"
                                            id="aantalKilometersNaartArtsZiekenhuis"
          >
          </snelstart-ui-number-form-control>
          <snelstart-ui-number-form-control [decimals]="0"
                                            [disabledControl]="aangifteJaar > 2024"
                                            [label]="i === 0 ? 'Km-prijs (in centen)' : ''"
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="prijsPerKilometerInCenten"
                                            id="prijsPerKilometerInCenten"
                                            postfix="ct"
          >
          </snelstart-ui-number-form-control>
          <snelstart-ui-number-form-control [decimals]="0"
                                            [label]="i === 0 ? 'Uitgaven OV en overig' : ''"
                                            align="right"
                                            class="col-auto custom-input-175"
                                            formControlName="uitgavenOpenbaarVervoerEnOverigVervoer"
                                            id="uitgavenOpenbaarVervoerEnOverigVervoer"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
          <snelstart-ui-number-form-control [decimals]="0"
                                            [label]="i === 0 ? 'Extra reiskosten ziekte' : ''"
                                            [placeholder]="aangifteJaar > 2024 ?  'Zie toelichting' : ''"
                                            align="right"
                                            class="col-auto custom-input-175"
                                            formControlName="extraReisKostenZiekteInvaliditeit"
                                            id="extraReisKostenZiekteInvaliditeit"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
          <snelstart-ui-button (click)="verwijderRij(i)"
                               [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
                               icon="trash"
                               iconType="light"
                               id="buttonDeleteKosten"
                               size="medium"
                               type="secondary"
          >
          </snelstart-ui-button>
        </div>
      }
    </div>
  </form>

  <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button pb-3" icon="plus"
                       type="link">Reiskosten eigen zorg
  </snelstart-ui-button>

}
